// extracted by mini-css-extract-plugin
export default {"activate":"style_activate__P+kYd","bonuses":"style_bonuses__5iJ7-","input":"style_input__NhyQY","accept":"style_accept__39FMZ","cancel":"style_cancel__es9Q7"};